import { computed } from "mobx";
import { useMemo } from "react";

import { buildTaskRows } from "@/pages/agent/tasks/agent-tasks-page.utils";
import type { AppStore } from "@/store";

/**
 * Keeps the expensive task relationship join cached across URL-only rerenders.
 *
 * MobX invalidates the computed value when any contributing task, project,
 * follow-up, note reference, or source note changes. Switching filters or task
 * views can therefore reuse the same rows without making them stale.
 */
export const useAgentTaskRows = ({ store }: { store: AppStore }) => {
  const taskRows = useMemo(
    () =>
      computed(() =>
        buildTaskRows({
          tasks: store.assistantTasks.currentAssistantModels,
          projects: store.assistantProjects.currentAssistantModels,
          followUps: store.assistantFollowUps.currentAssistantModels,
          taskNoteReferences: store.assistantTaskNoteReferences.currentAssistantModels,
          getNoteById: store.notes.getNoteObservableById,
        })
      ),
    [store]
  );

  return taskRows.get();
};
